import React, { Component } from 'react';
import Page from './Page';
import Update from './Update';
import ExecuteSider from '../ExecuteSider';
import QualitySideNav from '../../qualityManagement/SideNav';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';

class ImportantEvent extends Component {
    state = {
        data: {},
        status: '',
        config: {},
        maxDate: '',
    }

    componentDidMount() {
        this.queryDate();
        this.queryConfig();
    }

    queryDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { date } = res;
            const maxDate = date;
            this.setState({ maxDate });
        });
    }

    queryConfig = () => {
        dictCache.getDict('MAJOR_EVENT_CONFIG', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.execute.queryConfigureList,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ config: res });
        });
    }

    handleChange = (data, status) => {
        this.setState({
            data,
            status,
        });
    }

    render() {
        const { data, status, config, maxDate } = this.state;
        const { investigationSiteName } = sessionStorage;
        const isInProject = !!investigationSiteName;
        // 布局强制最小页高约为 header(73)+nav(46)+content(770)+footer(41)≈930px；
        // 可视区高度小于该值时（如系统缩放150%），取消 770px 最小高度，让整页收缩进可视区，避免底部大片留白
        const fitViewport = document.documentElement.clientHeight < 930;
        return (
            <div className={`content${fitViewport ? ' fit-viewport' : ''}`}>
                {
                    isInProject ?
                        <ExecuteSider selectKey='importantEvent' />
                    :
                        <QualitySideNav selectKey='importantEvent' />
                }
                <div className="main" style={{ display: status ? 'none' : 'block' }}><Page status={status} config={config} maxDate={maxDate} onChange={this.handleChange} /></div>
                { status && <Update data={data} config={config} maxDate={maxDate} status={status} onChange={this.handleChange} /> }
            </div>
        );
    }
}

export default ImportantEvent;


// WEBPACK FOOTER //
// ./src/components/execute/importantEvent/index.js